// Types
import { PayState, PayPalData, AvailableCreditCardsData, APIActionDataResponse, SavedPaymentMethod } from 'types'

export const initialState: PayState = {
  savedPaymentMethod: undefined,
  creditCards: undefined,
  paypal: undefined,
}

type FetchAvailablePaymentMethodsAction = {
  type: 'FETCH_AVAILABLE_PAYMENT_METHODS_DONE'
  data: {
    response: Array<AvailableCreditCardsData | PayPalData>
  }
}

type FetchProfileAction = APIActionDataResponse & {
  type: 'FETCH_PROFILE_DONE'
}

type AddNewCardAction = {
  type: 'ADD_NEW_CARD_DONE'
  data: {
    response: SavedPaymentMethod | { resultCode: 'RedirectShopper' }
  }
}
type SaveExternalPaymentMethod = {
  type: 'SAVE_EXTERNAL_PAYMENT_METHOD_DONE'
  data: {
    response: SavedPaymentMethod
  }
}

type RemoveSavedPaymentMethod = {
  type: 'REMOVE_SAVED_PAYMENT_METHOD_DONE'
}

type PayDoneActions =
  | FetchAvailablePaymentMethodsAction
  | FetchProfileAction
  | AddNewCardAction
  | SaveExternalPaymentMethod
  | RemoveSavedPaymentMethod

export const reducer = (state: PayState = initialState, action: PayDoneActions): PayState => {
  switch (action.type) {
    case 'FETCH_AVAILABLE_PAYMENT_METHODS_DONE': {
      const {
        data: { response },
      } = action
      return {
        ...state,
        creditCards: response.find(({ name }) => name.toLowerCase() === 'credit card') as AvailableCreditCardsData,
        paypal: response.find(({ name }) => name.toLowerCase() === 'paypal') as PayPalData,
      }
    }

    case 'REMOVE_SAVED_PAYMENT_METHOD_DONE': {
      return {
        ...state,
        savedPaymentMethod: undefined,
      }
    }

    case 'SAVE_EXTERNAL_PAYMENT_METHOD_DONE':
    case 'ADD_NEW_CARD_DONE': {
      const {
        data: { response },
      } = action
      if ('resultCode' in response) {
        return state
      }
      return {
        ...state,
        savedPaymentMethod: response as SavedPaymentMethod,
      }
    }

    case 'FETCH_PROFILE_DONE': {
      const {
        data: {
          response: {
            entities: { profiles },
          },
        },
      } = action
      const profile = Object.values(profiles || {})[0]
      if (profile && profile.saved_payment_methods_remote.length) {
        return {
          ...state,
          savedPaymentMethod: profile.saved_payment_methods_remote[0],
        }
      }
      return state
    }

    default:
      return state
  }
}

export default reducer
